import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IomService } from 'src/app/services/iom.service';
import { SessionService } from 'src/app/services/session.service';
import { ExcelUploadResponse, DomainMappingRequest } from 'src/app/models/ExcelUploadResponse';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'src/app/services/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { timeout } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
declare var bootbox: any;


declare var $: any;
@Component({
  selector: 'app-upload-excel',
  templateUrl: './upload-excel.component.html',
  styleUrls: ['./upload-excel.component.css']
})
export class UploadExcelComponent implements OnInit {
  //@Output() enableCreateDDTab = new EventEmitter<number>(); 

  btnText: string = "Next";
  displayMappingDiv: boolean = false;
  displayMappingTable: boolean = false;
  files: any[] = [];
  SelectedMapping: string = "";
  MappingData: { FieldValue: string, IsAO: boolean, IsIO: boolean, IsOthers: boolean }[] = [];
  MappingFilterData: { FieldValue: string, IsAO: boolean, IsIO: boolean, IsOthers: boolean }[] = [];
  HistoricalDomainMapping: { MappingFiled: string, MappingValue: string, Domain: string }[];
  categorisedBy: { Key: string, Value: string[] }[]; // = [{"Key":"Assigned_Group","Value":["Assigned Group 1","Assigned Group 6","Assigned Group 7","Assigned Group 8","Assigned Group 9","Assigned Group 10","Assigned Group 11","Assigned Group 12","Assigned Group 13","Assigned Group 14","Assigned Group 15","Assigned Group 16"]},{"Key":"Ticket Source","Value":["Email","Phone","Self-service","Auto","Chat","Walk-in"]},{"Key":"Severity","Value":["4","3","2"]},{"Key":"SLA","Value":["Met","Breached"]},{"Key":"Business_Section","Value":["Business Section1","Business Section2","s","Business Section4","Business Section3"]}]
  all_Others: boolean = false;
  all_AO: boolean = false;
  all_IO: boolean = false;
  CreateDDInput: ExcelUploadResponse = new ExcelUploadResponse();
  HistoryCreateDDInput: ExcelUploadResponse = new ExcelUploadResponse();
  IsMappingCompleted: boolean;
  DomainMappingRequest: DomainMappingRequest = new DomainMappingRequest();
  displayCancel: boolean = false;
  ProposalId: string;
  constructor(private spinner: NgxSpinnerService, private IOMService: IomService, private messageService: MessageService, private SessionService: SessionService, private router: Router, private route: ActivatedRoute) { }
  ngOnInit(): void {
    //this.HistoryCreateDDInput = JSON.parse(this.SessionService.getSessionStorageItem("CreateDDInput"));
    //this.ProposalId = parseInt(this.SessionService.getSessionStorageItem("selectedProposalId"));
    this.ProposalId = this.SessionService.getDeliveryConstructUId();
    // if(!this.HistoryCreateDDInput.BAUploadedData)
    // {
    $(window).scroll(function () {
      if ($(this).scrollTop() >= $('.myw-topbar').offset().top)
        $('body').addClass('myw-sticky');
      else
        $('body').removeClass('myw-sticky');
    }).trigger('scroll');

    $(document).ready(function () {
      $('.download-action').click(function () {
        $(this).parents('.iom-download').addClass('iom-download-success');
        document.getElementById("chooseFile").style.visibility = "visible";
      });
    });
    var input = document.getElementById('file-upload');
    //document.getElementById("chooseFile").style.visibility = "hidden";
    document.getElementById('displayFileName').style.visibility = "hidden";
    document.getElementById('btnValidate').style.visibility = "hidden";
    //}    
  }
  UploadExcelFile(e): void {
    this.spinner.show();
    //setTimeout(()=> {}, 3000);
    this.files = e.target.files;
    let fileName = this.files[0].name;
    document.getElementById('displayFileName').style.visibility = "visible";
    document.getElementById('btnValidate').style.visibility = "visible";
    var displayselectedFileName = document.getElementById('file-upload-filename');
    displayselectedFileName.innerText = fileName;
    document.getElementById("chooseFile").style.visibility = "hidden";
    this.spinner.hide();
  }
  async fileUpload(btnText: string) {
    if (this.files.length > 0) {
      let fileName = this.files[0].name;
      let fileSize = this.files[0].size;
      let chunkSize = this.IOMService.chunkSize;
      if (fileName.split('.').pop().toLowerCase() == 'xlsx') {
        if (fileName.split('.').length != 2) {
          this.spinner.hide();
          this.deleteFile(true);
          bootbox.alert('Invalid file Extension. Expected Extension is .xslx');
          return;
        }
        //frmData.append("ExcelFile", this.files[0]);
        this.DomainMappingRequest.ProposalId = this.ProposalId; // it would be deliveryconstructUID       
        this.DomainMappingRequest.UserId = this.SessionService.getUserName();
        this.DomainMappingRequest.UserType = parseInt(this.SessionService.getUserType());
        this.spinner.show();
        let totalChunkCount = Math.ceil(fileSize / chunkSize);
        let fileReferenceId = this.DomainMappingRequest.UserId + '_' + new Date().toISOString().replace(/[^\w]/g, ""); // unique Id
        this.CreateDDInput.fileName = fileReferenceId + '_' + fileName;
        let i = 0;
        for (let start = 0; start < fileSize; start += chunkSize) {
          let chunk = this.files[0].slice(start, start + chunkSize)
          let fd = new FormData()
          fd.append('chunkIndex', i.toString());
          fd.append('maxChunkIndex', totalChunkCount.toString());
          fd.append("ExcelFile", chunk);
          fd.append('fileReferenceId', fileReferenceId);
          fd.append("fileName", this.CreateDDInput.fileName);
          try {            
            this.IOMService.uploadExcelDataByChunks<any>(fd).subscribe(data => {
              if (data != undefined && data != null && data.result == "Success") {
                if (i == (totalChunkCount - 1)) {
                   // this.spinner.hide();
                    this.SessionService.setSessionStorageItem("FileName", this.CreateDDInput.fileName);
                    this.SessionService.setSessionStorageItem("ExelUserType", this.DomainMappingRequest.UserType.toString());
                    // navigate to Attribute mapping                                
                  }
                  i++;                  
                    this.IOMService.CheckDuplicateColName<any>(fd).subscribe(data => {
                      //this.spinner.hide();
                      if (data != undefined && data != null && data.result == "Success") {
                        if(this.SessionService.getSessionStorageItem('reUpload') == "true"){
                          this.fileReUpload();
                        }
                        else{
                          // navigate to Attribute mapping 
                          this.spinner.show(); 
                          this.messageService.updateNavigateToAttributeMapTab(true);
                        }
                      }
                      else if (data.result == "duplicate"){
                        this.spinner.hide();
                        bootbox.alert("Uploaded Excel having duplicate columns (" + data.columnName + "). Please rename any one of the column name and upload it again.");
                      }
                      else{
                        this.spinner.hide();
                        bootbox.alert("Error Occured !");
                      }
                    },
                      (err: HttpErrorResponse) => {
                        this.spinner.hide();
                        bootbox.alert("Error Occured !");
                      });
                  }
              else {
              this.spinner.hide();
              bootbox.alert("Chunk Upload Failed!");
              // throw new Error("Chunk Upload Failed");
              }                  
          },
          (err: HttpErrorResponse) => {
            this.spinner.hide();
            bootbox.alert("Error Occured !");
          });
            // if (response.response == "Success") {
                  
          } catch (err) {
            this.spinner.hide();
            bootbox.alert("Error occured in fileupload");
            //console.log(err);
            break;
          }
        }
      }
      else {
        this.spinner.hide();
        this.deleteFile(true);
        bootbox.alert('Invalid file format. Expected format is .xslx');
        return;
      }
    }
    else {
      this.spinner.hide();
      bootbox.alert("Please upload the ticket data");
      return false;
    }
  }
  fileUpload_old(btnText: string) {
    let frmData = new FormData();
    if (this.files.length > 0) {
      let fileName = this.files[0].name;
      if (fileName.split('.').pop().toLowerCase() == 'xlsx') {
        frmData.append("ExcelFile", this.files[0]);
        frmData.append("ProposalId", this.ProposalId.toString());
        this.DomainMappingRequest.ProposalId = this.ProposalId;
        this.DomainMappingRequest.UserId = this.SessionService.getUserName();
        this.DomainMappingRequest.UserType = parseInt(this.SessionService.getUserType());
        frmData.append("UserType", this.DomainMappingRequest.UserType.toString());
        this.spinner.show();
        this.IOMService.UplodExcelFile(frmData).pipe(timeout(2400000)).subscribe((data: any) => {
          this.spinner.hide();
          if (data) {
            if (data.Message && data.Message == "Success") {
              document.getElementById('uploadsuccess').style.visibility = "visible";
              document.getElementById('uploadsuccess').innerText = "Upload Success";
              this.btnText = "Next";
              this.displayMappingDiv = true;
              //this.CreateDDInput.BAUploadedData = data.BAUploadData;
              this.CreateDDInput.DisplayLongDesc = data.DisplayLongDesc;
              this.CreateDDInput.DisplayResolutionDesc = data.DisplayResolutionDesc;
              this.CreateDDInput.ExcelMappingFields = data.ExcelMappingFields;
              this.CreateDDInput.MinTicketDate = data.MinTicketDate;
              this.CreateDDInput.MaxTicketDate = data.MaxTicketDate;
              this.CreateDDInput.TicketTypes_AO = data.TicketTypes;
              this.CreateDDInput.TicketTypes_IO = data.TicketTypes.slice(0, 2);
              this.CreateDDInput.MandatoryColumns = data.MandatoryColumns;
              this.CreateDDInput.ActualColumns = data.ActualColumns;
              this.CreateDDInput.WordCloudFilterOptions = data.WordCloudFilterOptions;
              this.categorisedBy = data.CategorisedBy ? data.CategorisedBy : [];
              this.HistoricalDomainMapping = data.HistoricalDomainMapping ? data.HistoricalDomainMapping : [];
              //this.categorisedBy.map(x => x.Key = (x.Key == x.Key.toUpperCase() ? x.Key.trim().replace(/[^a-zA-Z0-9]/g, ' ') : this.toPascalCase(x.Key).replace(/([A-Z])/g, ' $1').trim())); //.match(/^[A-Z]*$/)
              this.categorisedBy.map(x => x.Key = x.Key.replace(/[^a-zA-Z0-9]/g, ' '));
              this.CreateDDInput.CategorisedByDD = this.categorisedBy;
              this.CreateDDInput.HistoricalDomainMapping = this.HistoricalDomainMapping;
              this.CreateDDInput.CategorisedBy = this.categorisedBy.map(x => x.Key).map(name => ({ name }));
              this.SessionService.setSessionStorageItem("CreateDDInput", JSON.stringify(this.CreateDDInput));
              this.messageService.updateBAUploadedData(data.BAUploadData);
              this.messageService.updateNavigateToCreateDDTab(true);
            }
            else
              bootbox.alert(data.Message);
          }
          else {
            document.getElementById('uploadsuccess').style.visibility = "visible";
            document.getElementById('uploadsuccess').innerText = "Upload Failed";
            bootbox.alert("Error occured in fileuplod");
            //this.deleteFile(true);
          }
        },
          (err: HttpErrorResponse) => {
            this.spinner.hide();
            document.getElementById('uploadsuccess').style.visibility = "visible";
            document.getElementById('uploadsuccess').innerText = "Upload Failed";
            if (err.message != "Timeout has occurred") {
              bootbox.alert(err.message);
              //this.deleteFile(true);
            }
          });
      }
      else {
        this.deleteFile(true);
        bootbox.alert('Invalid file format. Expected format is .xslx');
        return;
      }
    }
    else {
      bootbox.alert("Please upload the ticket data");
      return false;
    }
  }
  SaveDomainMappingData(domainMappingRequest: DomainMappingRequest) {
    this.IOMService.SaveDomainMappingData(domainMappingRequest).subscribe((data: any) => {
      if (data) {
        console.log("Success");
      }
    },
      (err) => {
        //console.log(err);
      }
    );
  }
  searchDomainMapping(searchText: string) {
    //console.log(searchText);
    this.MappingFilterData = null;
    if (searchText == "") {
      this.MappingFilterData = this.MappingData;
    }
    else {
      searchText != "" ? this.MappingFilterData = this.MappingData.filter(filterValue => {
        return filterValue.FieldValue != undefined ? filterValue.FieldValue.toLowerCase().trim().includes(searchText.toLowerCase().trim()) : false
      })
        : this.MappingFilterData == undefined ? this.MappingFilterData = null : '';
    }

  }
  ValidateInputs(): boolean {
    if (!this.SelectedMapping || this.SelectedMapping == 'Select') {
      bootbox.alert("Please select the valid feature to map the tickets");
      return false;
    }
    else if (!this.IsMappingCompleted) {
      bootbox.alert("Domain mapping is incomplete");
      return false;
    }
    return true;
  }
  //Convert Mapping Options to Pascal Case
  toPascalCase(string) {
    return `${string}`
      .replace(new RegExp(/[-_]+/, 'g'), ' ')
      .replace(new RegExp(/[^\w\s]/, 'g'), '')
      .replace(
        new RegExp(/\s+(.)(\w+)/, 'g'),
        ($1, $2, $3) => `${$2.toUpperCase() + $3.toLowerCase()}`
      )
      .replace(new RegExp(/\s/, 'g'), '')
      .replace(new RegExp(/\w/), s => s.toUpperCase());
  }
  deleteFile(ClearDataAlone: boolean) {
    if (!ClearDataAlone) {
      document.getElementById('displayFileName').style.visibility = "hidden";
      document.getElementById('btnValidate').style.visibility = "hidden";
      document.getElementById('file-upload-filename').innerText = "";
      document.getElementById('uploadsuccess').style.visibility = "hidden"
      document.getElementById('uploadsuccess').innerText = "";
      document.getElementById("chooseFile").style.visibility = "visible";
    }
    this.files = [];
    this.displayMappingDiv = false;
    this.btnText = "Next";
    this.CreateDDInput = new ExcelUploadResponse();
    this.SelectedMapping = null;
  }
  LoadMappingData() {
    this.MappingData = [];
    this.all_AO = false;
    this.all_IO = false;
    this.all_Others = false;
    let data = this.categorisedBy.find(x => x.Key == this.SelectedMapping);
    let historyDataForSelectedMappingField = this.HistoricalDomainMapping.filter(x => x.MappingFiled.toLocaleLowerCase().trim() == this.SelectedMapping.toLocaleLowerCase().trim());
    if (data) {
      this.displayMappingTable = true;
      for (const value of data.Value) {
        var historyIndex = historyDataForSelectedMappingField.findIndex(x => x.MappingValue.toLowerCase().trim() == value.toLowerCase().trim());
        if (historyIndex >= 0) {
          var historyDomain = historyDataForSelectedMappingField[historyIndex].Domain;
          this.MappingData.push({ FieldValue: value, IsAO: historyDomain == 'AO', IsIO: historyDomain == 'IO', IsOthers: historyDomain == 'Others' });
        }
        else {
          this.MappingData.push({ FieldValue: value, IsAO: false, IsIO: false, IsOthers: false });
        }
        this.MappingFilterData = this.MappingData;
      }
      if (this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
        this.all_AO = true;
      if (this.MappingData.filter(x => x.IsIO).length == this.MappingData.length)
        this.all_IO = true;
      if (this.MappingData.filter(x => x.IsOthers).length == this.MappingData.length)
        this.all_Others = true;
      if (this.MappingData.filter(x => x.IsOthers).length + this.MappingData.filter(x => x.IsIO).length + this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
        this.IsMappingCompleted = true;
      else
        this.IsMappingCompleted = false;
    }
    else {
      this.displayMappingTable = false;
    }
  }
  OnDomainChange(mData: { FieldValue: string, IsAO: boolean, IsIO: boolean, IsOthers: boolean }, domain: string, isAllControl: boolean) {
    if (isAllControl) {
      switch (domain) {
        case 'AO':
          this.MappingData.map(x => x.IsAO = true);
          this.MappingData.map(x => x.IsIO = false);
          this.MappingData.map(x => x.IsOthers = false);
          break;
        case 'IO':
          this.MappingData.map(x => x.IsAO = false);
          this.MappingData.map(x => x.IsIO = true);
          this.MappingData.map(x => x.IsOthers = false);
          break;
        case 'Others':
          this.MappingData.map(x => x.IsAO = false);
          this.MappingData.map(x => x.IsIO = false);
          this.MappingData.map(x => x.IsOthers = true);
          break;
        default:
          break;
      }
    }
    else {
      let objIndex = this.MappingData.findIndex((obj => obj.FieldValue == mData.FieldValue));
      if (objIndex != -1) {
        switch (domain) {
          case 'AO':
            this.MappingData[objIndex].IsAO = true;
            this.MappingData[objIndex].IsIO = false;
            this.MappingData[objIndex].IsOthers = false;
            break;
          case 'IO':
            this.MappingData[objIndex].IsAO = false;
            this.MappingData[objIndex].IsIO = true;
            this.MappingData[objIndex].IsOthers = false;
            break;
          case 'Others':
            this.MappingData[objIndex].IsAO = false;
            this.MappingData[objIndex].IsIO = false;
            this.MappingData[objIndex].IsOthers = true;
            break;
          default:
            break;
        }
      }
    }
    if (this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
      this.all_AO = true;
    else
      this.all_AO = false;
    if (this.MappingData.filter(x => x.IsIO).length == this.MappingData.length)
      this.all_IO = true;
    else
      this.all_IO = false;
    if (this.MappingData.filter(x => x.IsOthers).length == this.MappingData.length)
      this.all_Others = true;
    else
      this.all_Others = false;
    if (this.MappingData.filter(x => x.IsOthers).length + this.MappingData.filter(x => x.IsIO).length + this.MappingData.filter(x => x.IsAO).length == this.MappingData.length)
      this.IsMappingCompleted = true;
    else
      this.IsMappingCompleted = false;
  }

  CancelTicketUpload() {    
    if (this.router.url.startsWith('/createdeepdive')) {
      if(this.SessionService.getSessionStorageItem('reUpload') == "true"){
        var VersionId = this.SessionService.getSessionStorageItem('reUploadversionID'); 
        this.IOMService.DeleteExcelFile(this.CreateDDInput.fileName);
        this.IOMService.CancelReUpload(VersionId).subscribe((data: any) => {  
        },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          console.log("Error Occured !");
        });                     
        this.router.navigate(['deepdive']);
      }
      else{
        this.IOMService.DeleteExcelFile(this.CreateDDInput.fileName);
        if (this.SessionService.getSessionStorageItem('userType') != '4')
          this.router.navigate(['deepdive']);
        else
          this.router.navigate(['deepdive'], { queryParams: { SolutionId: this.SessionService.getSolutionId() } });
      }
    }
    else {
      this.router.navigate(['proposalsummary']);
    }
  }

  fileReUpload(){
    let that = this;
    var VersionId = this.SessionService.getSessionStorageItem('reUploadversionID');
    var FileName = this.CreateDDInput.fileName;
    this.IOMService.FileReUpload(VersionId,FileName).subscribe((data: any) => {
      this.spinner.hide();
      if (data != undefined && data != null && data.Result != null && data.Result != undefined) {   
        if(data.Result == "Success" && data.Count <= 450000){
          bootbox.confirm({
            message: 'There are totally ' + data.Count + ' tickets available for the selected deepdive excluding previously selected filters. Please click on proceed to perform live ticket categorization',
            buttons: {
              confirm: {
                label: 'Proceed',
                className: 'btn-primary'
              },
              cancel: {
                label: 'Cancel',
                className: 'btn-secondary'
              }
            },
            callback: function (result) {
              if (result) //'Yes' selection
              {                
                that.spinner.show();
                that.IOMService.LiveCategorizationStandalone(VersionId).subscribe((data: any) => {
                  if (data != undefined && data != null && data.Result != null && data.Result != undefined) {   
                    if(data.Result == "Success"){ 
                    that.spinner.hide();
                    bootbox.confirm({
                      message: "Deepdives initiated successfully",
                      buttons: {
                        confirm: {
                          label: 'Ok',
                          className: 'btn-primary'
                        },
                        cancel: {
                          label: 'Cancel',
                          className: 'd-none'
                        }
                      },
                      callback: function (result) {
                        if (result) //'Yes' selection
                        {                       
                        }
                      }
                    });                       
                    that.messageService.updateDDredirection('reupload'); 
                    that.router.navigate(['deepdive']);                    
                  }
                  else{
                    that.spinner.hide();
                    bootbox.alert("Live Categorization failed.");
                  }
                }
                  else{    
                    that.spinner.hide();               
                    bootbox.alert("Live Categorization failed.");
                  }
                },
                  (err: HttpErrorResponse) => {
                    that.spinner.hide();
                    console.log("Error Occured !");
                  });
              }              
            }
          });
        }
        else if (data.Result == "Success" && data.Count > 450000){
          that.spinner.hide();
          bootbox.alert("Ticket count should not exceed 450000");
        }
        else if (data.Result != "" && data.Result != null){
          that.spinner.hide();
          bootbox.alert(data.Result);
        }
        else{
          that.spinner.hide();
          bootbox.alert("File Reupload failed.");
        }
      }
      else{
        that.spinner.hide();
        bootbox.alert("Live Categorization failed.");
      }
    }
      ,
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
  }
}
